











import { Component, Prop } from 'vue-property-decorator';
import Modal from './Modal.vue';
import { EVENTS } from '@/author/constants';
import BaseComponent from './BaseComponent.vue';
import ModalAudioPlayer from './ModalAudioPlayer.vue';
import Flashcard from './Flashcard.vue';

@Component
export default class ModalStack extends BaseComponent {
  @Prop({default: false}) indexedOrder?: boolean;
  modals!: any[];
  lenghtCompleted = 0;
  completedModals: number[] = [];
  isInteractive :boolean = true;
  indexedModal = 0;

  created() {
    this.modals = this.$children;
    this.$on(EVENTS.COMPLETED, this.onEventsCompleted);
  }

  onEventsCompleted (hash:number) {
    if (hash) {
      this.completeModal(hash);
      this.checkIfStackIsCompleted();
    }
  }

  mounted() {
    this.modals = this.$children;
    var completed: boolean = this.getSavedData && this.getSavedData.completed;
    this.defineCompleteState(completed);
    this.setupModalsFromSavedData(this.getSavedData);
  }

  defineCompleteState(completed: boolean) {
    if (completed !== undefined && completed) 
      this.unlock();
    else 
      this.lockForward();
    
  }

  checkIfStackIsCompleted() {
    this.lenghtCompleted = 0;
    this.modals.forEach(modal => {
      //TODO: unify logic amongst children completion on modal
      const isGreaterIndex = this.indexedModal <= modal.indexNumber && this.indexedOrder;
      if ((modal as Modal || ModalAudioPlayer).completed) {
        if(isGreaterIndex) this.indexedModal = modal.indexNumber + 1;
        if (this.indexedOrder) this.$emit('open-modal', this.indexedModal);
        this.lenghtCompleted += 1;
      }else if((modal as Flashcard).isFlipped) this.lenghtCompleted += 1;
    });

    if (this.completed) this.unlock();
    this.saveData({
      completedModals: this.completedModals,
      completed: this.completed
    });
  }

  completeModal(hash: number) {
    if (this.completedModals.indexOf(hash) === -1)
      this.completedModals.push(hash);
    this.saveData({
      completedModals: this.completedModals,
      completed: this.completed
    });
  }

  setupModalsFromSavedData(savedData: any) {
    if (savedData && savedData.completedModals) {
      this.completedModals = savedData.completedModals;
      if (this.indexedOrder) this.indexedModal = savedData.completedModals.length;
      this.completedModals.map(hash => {
        this.$emit('setup-modal', hash);
        if (this.indexedOrder) this.$emit('open-modal', this.indexedModal);
      });
    }
  }

  get completed(): boolean {
    return this.modals.length === this.lenghtCompleted;
  }
}
